import { registerEnumType } from 'type-graphql'

export enum FeatureFlagKeyEnum {
  CUSTOMER_LAYOUT = 'CUSTOMER_LAYOUT',
}

registerEnumType(FeatureFlagKeyEnum, {
  name: 'FeatureFlagKeyEnum',
  description: 'Available feature flag keys',
})
